import PaymentList from "../../components/Payment/PaymentList";

export default function Payment(){
    return(
        <div>
            <PaymentList/>
        </div>
    )
}